import { render, staticRenderFns } from "./FundingProjectItem.vue?vue&type=template&id=6b30455e&"
import script from "./FundingProjectItem.vue?vue&type=script&lang=js&"
export * from "./FundingProjectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports